const getActivityModeStorageKey = () => {
  const storedUser = localStorage.getItem('user');
  if (!storedUser) return 'activityMode';
  try {
    const user = JSON.parse(storedUser);
    const identifier = user?.accountId || user?.id || user?.email || 'default';
    return `activityMode:${identifier}`;
  } catch {
    return 'activityMode';
  }
};

export const loadActivityMode = () => {
  try {
    const key = getActivityModeStorageKey();
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

export const saveActivityMode = (mode) => {
  try {
    const key = getActivityModeStorageKey();
    localStorage.setItem(key, JSON.stringify(mode));
  } catch {
    // ignore
  }
};

export const clearActivityMode = () => {
  try {
    const key = getActivityModeStorageKey();
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
};

export const ACTIVITY_MODES = [
  { id: 'electrician', label: 'Électricien', presetCatalogId: 'electrician' },
  { id: 'plumber', label: 'Plombier', presetCatalogId: 'plumber' },
  { id: 'construction', label: 'Artisan bâtiment', presetCatalogId: 'btp' },
  { id: 'freelance', label: 'Freelance', presetCatalogId: 'freelance' },
  { id: 'beauty', label: 'Beauté', presetCatalogId: 'beauty' },
  { id: 'other', label: 'Autre', presetCatalogId: 'services' },
];

export const getActivityModeMeta = (id) => ACTIVITY_MODES.find((m) => m.id === id) || null;
